import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/vercel/path0/middleware/auth.global.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  account: () => import("/vercel/path0/middleware/account.js"),
  admin: () => import("/vercel/path0/middleware/admin.js"),
  guest: () => import("/vercel/path0/middleware/guest.js"),
  manager: () => import("/vercel/path0/middleware/manager.js"),
  "not-customer": () => import("/vercel/path0/middleware/notCustomer.js"),
  superadmin: () => import("/vercel/path0/middleware/superadmin.js")
}